/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 // Promobar message slider

 var promoMessageIndex = 0;
 showPromoMessage();

 function showPromoMessage() {
   var i;
   var messages = document.getElementsByClassName("Announcement");
   for (i = 0; i < messages.length; i++) {
     messages[i].classList.remove("PromoFade");
   }
   promoMessageIndex++;
   if (promoMessageIndex > messages.length) {promoMessageIndex = 1}
   messages[promoMessageIndex-1].classList.add("PromoFade");
   setTimeout(showPromoMessage, 4400); // Change message every 4 seconds
 }

window.addEventListener('load', function() {
    let name = 'cookie-banner';
    let value = 'cookie-banner';
    let days = 90;
    let domain = document.domain;
    let cookieBanner = getCookie(name);

    if (!cookieBanner) {
        displayCookieBanner();
    }

    document.getElementById('cookie-banner-close').addEventListener('click', function(event) {
        event.preventDefault();

        if (!cookieBanner) {
            setCookie(name, value, days, domain);
        }

        hideCookieBanner();
    });

    function hideCookieBanner() {
        document.getElementsByClassName('cookie-banner')[0].style.display = 'none';
    }

    function displayCookieBanner() {
        document.getElementsByClassName(name)[0].style.display = 'flex';
    }

    function setCookie(name,value,days,domain) {
        let expires = "";
        let date = new Date();

        if (days) {
            date.setTime(date.getTime()+(days*24*60*60*1000));
            expires = "; expires="+date.toGMTString();
        }

        if (domain) {
            document.cookie = name+"="+value+expires+"; path=/; domain=" + domain;
        } else {
            document.cookie = name+"="+value+expires+"; path=/";
        }
    }

    function getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');

        for (let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
});

//  We need this before our scripts (this will expose Size Matter's configuration options):
!function(a){a._empty=a._empty||[],a._beforeRender=a._beforeRender||[],a._afterRender=a._afterRender||[],a._renderedAll=a._renderedAll||[],a._overrideContent=a._overrideContent||function(a){return a.content},a.onEmpty=function(b){b&&a._empty.push(b)},a.onBeforeRender=function(b){b&&a._beforeRender.push(b)},a.onAfterRender=function(b){b&&a._afterRender.push(b)},a.onRenderedAll=function(b){b&&a._renderedAll.push(b)},a.overrideCellContent=function(b){a._overrideContent=b}}(window.eastsideco_sizeGuides||(window.eastsideco_sizeGuides={}));

// Here we're mixing a callback that detects when the charts are finished rendering
// and a snippet from the SizeMatters support team.
document.addEventListener("DOMContentLoaded", function() {
    var SizeMatters = window.eastsideco_sizeGuides;
    SizeMatters.onRenderedAll(function(data) {
        var button = document.querySelector('[data-app="eastsideco_sizeGuides"] a');
        var modal_close = document.querySelector(".modal_close");
        var modal_background = document.querySelector(".modal_background");
        var element = document.body.querySelector(".esc-size-guide--popup");
        var body = document.getElementsByTagName("body")[0];

        modal_close.addEventListener("click", event => {
            body.style.overflow = "unset";
        });

        modal_background.addEventListener("click", event => {
            body.style.overflow = "unset";
        })

        button.addEventListener("click", event => {
            body.style.overflow = "hidden";
        });

        button.addEventListener("click", event => {
            if (element.style.display === "none") {
                body.style.overflow = "unset";
            }
        });
    });
});

/** play product video when click on the product thumbnail **/
var thumbnail = document.querySelectorAll('.Product__SlideshowNavImage');
var videos = document.querySelectorAll('video');
if (thumbnail) {
    thumbnail.forEach(function (element) {
        element.addEventListener("click", function (e) {
            var current_element = this.getAttribute('href');
            videos.forEach(function (e) {
                e.pause();
            });

            if (current_element) {
                var current_side = document.querySelector(current_element);
                if (current_side) {
                    setTimeout(function () {
                        var current_slide_video = current_side.querySelectorAll('video');
                        if (current_slide_video) {
                            current_slide_video.forEach(function (ve) {
                                ve.play();
                            });
                        }
                    }, 500);
                }
            }
        });
    });
}
/** --play product video when click on the product thumbnail **/


/** play product video when it will be in view port **/
let all_videos = document.querySelectorAll('video');
let observerOptions = {
    threshold: [],
};
let thresholdSets = [
    []
];

for (let i = 0; i <= 1.0; i += 0.01) {
    thresholdSets[0].push(i);
    observerOptions.threshold = thresholdSets[0];
}

all_videos.forEach(function (video) {
    let isPaused = true;

    observerOptions.threshold = thresholdSets[0];

    let observer = new IntersectionObserver((entries, observerOptions) => {
        entries.forEach(entry => {
            if (window.screen.width > 1007) {
                if (entry.intersectionRatio != 0 && entry.target.paused) {
                    entry.target.play();
                    isPaused = false;
                } else if (isPaused == false) {
                    entry.target.pause();
                    isPaused = true
                }
            }
        });
    });

    observer.observe(video);
});
/** --play product video when it will be in view port **/

if(typeof $.fancybox == "function") {
  jQuery(document).on( 'click', '.product-modal', function(e) {
    e.preventDefault();
    $.fancybox.close( true );
    var url = jQuery(this).attr('href');
    $.fancybox.open({
      href: url,
      helpers: {
        overlay: {
          locked: true
        }
      },

      maxWidth: 920,
      width: "90%",
      minHeight: 525,
      height: 575,
      autoSize: false,
      showCloseButton : true,
      type: 'ajax',
      hideOnOverlayClick: true,
      afterShow: function () {
        document.dispatchEvent(new CustomEvent('theme:quickview:opened'));
        window.dispatchEvent(new Event('resize'));
      }
    });
  });
}

jQuery(document).ready(function ($) {
    var header_count = jQuery('.Header__CartCount').html();
    var new_count_updated = false;
    var intial = false;

    jQuery(document).on('click', '[data-drawer-id="sidebar-cart"]', function () {
        if (
            $('#sidebar-cart').find('#dynamic-checkout-cart').length > 0 &&
            jQuery.trim($('#sidebar-cart').find('#dynamic-checkout-cart').html()) == '' &&
            'function' === typeof window.bj_express_checkout
        ) {
            bj_express_checkout();
        }
    });

    jQuery(document).on('click', '[data-action="close-drawer"][data-drawer-id="sidebar-cart"]', function (event) {
        event.preventDefault();

        var $sidebarCart = $('#sidebar-cart');
        if ($sidebarCart.length === 0) {
            return;
        }

        $sidebarCart.attr('aria-hidden', 'true').attr('tabindex', 0);
        $('.PageOverlay').removeClass('is-visible');
        document.documentElement.classList.remove('no-scroll');

        if (typeof disableBodyScroll === 'function') {
            disableBodyScroll(false, '[data-scrollable]');
        }
    });

    jQuery(document).on('click', '[data-action="close-drawer"][data-drawer-id="sidebar-menu"]', function (event) {
        event.preventDefault();

        var $sidebarMenu = $('#sidebar-menu');
        if ($sidebarMenu.length === 0) {
            return;
        }

        $sidebarMenu.attr('aria-hidden', 'true').attr('tabindex', 0);
        $('.PageOverlay').removeClass('is-visible');
        document.documentElement.classList.remove('no-scroll');

        if (typeof disableBodyScroll === 'function') {
            disableBodyScroll(false, '[data-scrollable]');
        }
    });
        
    document.addEventListener('theme:rerenderCart', function (event) {
        if (parseInt(event.detail.item_count) > 0) {
            new_count_updated = true;
        }

        setTimeout(function () {
            if (
                $('#sidebar-cart').find('#dynamic-checkout-cart').length > 0 &&
                jQuery.trim($('#sidebar-cart').find('#dynamic-checkout-cart').html()) == '' &&
                'function' === typeof window.bj_express_checkout
            ) {

                if (intial == false && parseInt(header_count) == 0) {
                    intial = true;
                } else if (parseInt(event.detail.item_count) !== parseInt(header_count)) {
                    intial = true;
                    header_count = parseInt(event.detail.item_count);
                    new_count_updated = true;
                    bj_express_checkout();
                }
            }
        }, 300);
    });
});

function bj_getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

jQuery(document).on('click', '#sidebar-cart [name="checkout"], #shopify-section-cart-template [name="checkout"]', function($) {
  var exp_cookie = bj_getCookie( 'dynamic_checkout_shown_on_cart' );
  if ( exp_cookie ) {
    document.cookie = "dynamic_checkout_shown_on_cart=; expires= Thu, 01 Jan 1970 00:00:01 GMT;Path=/;";
  }
} );

jQuery(document).on('click', '.Footer__Inner .Footer__Block.Footer__Block--links .Footer__Title', function(){
  if( jQuery(window).width() < 641 ) {
    jQuery(this).toggleClass('show--menu');
  }
});
